module.exports = __webpack_public_path__ + "img/Pack_control_Diabète+.aa14d4aa.jpg";